import React from 'react';

const QuotePage = () => (
  <p className="quote border" data-testid="quoteParagraph">
    Mathematics is not about numbers,
    equations, computations, or algorithms:
    it is about understanding. -William Paul Thurston
  </p>
);

export default QuotePage;
